import { Skeleton } from "@/components/ui/skeleton";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { Target } from "lucide-react";
import React from "react";
import { WidgetTitle } from "@/components/widgets/WidgetTitle";

interface UserAvgSlaWidgetProps {
  loading?: boolean;
  value?: number | null;
}

function getSlaColorClass(displayValue: number): string {
  if (displayValue >= 80) return "text-success";
  if (displayValue >= 70) return "text-caution";
  return "text-destructive";
}

const UserAvgSlaWidget: React.FC<UserAvgSlaWidgetProps> = ({ loading, value }) => {
  const displayValue = value ?? 0;
  const colorClass = getSlaColorClass(displayValue);

  return (
    <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3">
      <div className="flex flex-row items-center justify-between">
        <WidgetTitle className="truncate">Avg SLA</WidgetTitle>
        <TooltipProvider>
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <span className="cursor-pointer">
                <Target className="h-4 w-4 text-primary dark:text-white" />
              </span>
            </TooltipTrigger>
            <TooltipContent side="top">
              <p className="max-w-xs text-xs">The number of incoming calls answered within a predetermined threshold (60 seconds by default) by all user within given time</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <div>
        {loading ? (
          <Skeleton className="h-16 w-full" />
        ) : (
          <div className={cn("text-[24px] font-[700] my-3", colorClass)}>
            {value != null ? `${value}%` : "0%"}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserAvgSlaWidget;
